import { useEffect } from "react";
import { useAuth } from "react-oidc-context";

const events = [
    "mousedown",
    "mousemove",
    "wheel",
    "keydown",
    "touchstart",
    "scroll"
];

const timeTillDeath = 1000 * 60 * 20;

const SessionKiller = () => 
    {

    const auth = useAuth();

    const checkForInactivity = () => {
        const expireTimeString = localStorage.getItem('expireTime');
        const expireTime = expireTimeString ? parseInt(expireTimeString) : 0;

        if (expireTime < Date.now()) {
            auth.signoutRedirect();
        }
    };
    
    const updateExpiryTime = () => {
        const expireTime = Date.now() + timeTillDeath;
        localStorage.setItem('expireTime', expireTime.toString());
    };

    useEffect(() => {
        updateExpiryTime();
        const update = () => {
            updateExpiryTime();
        };
        events.forEach(event => window.addEventListener(event, update));
    
        return () => {
            events.forEach(event => window.removeEventListener(event, update));
        };
    }, []);


    useEffect(() => {
        const interval = setInterval(() => {
            checkForInactivity();
        }, 5000); // Check for inactivity every 5 seconds

        return () => clearInterval(interval);
    }, []);

    return <></>

}

export default SessionKiller;